export default __webpack_public_path__ + "static/media/216property-gallery1.5bcd6f47.webp";